/**
 * Returns the id of the classroom of the student.
 *
 * TEMP This is very rudimentary while we assume that a student is only in one
 * class
 */
export const chooseStudentClassroom = (classroomIds: string[]): string => {
    return classroomIds[0];
};
